import {
  Component,
  Input,
  ViewChild,
  EventEmitter,
  Output,
  OnInit
} from '@angular/core';
import { cloneDeep, filter, indexOf } from 'lodash';
import {
  IWizardContentComponent,
  IValueChangedEvent,
  IComponentStateHistory
} from '../../../wizard.content';
import { NgForm } from '@angular/forms';
import { REMOVED } from '../../../services/base.wizard.step';
import { EntityCacheProvider } from '@nrwl/common-lib';

@Component({
  selector: 'threshold-application-selection-html',
  templateUrl: './threshold.application.selection.page.html',
  providers: [],
  styleUrls: ['./threshold.application.selection.page.scss', '../../../wizard.button.style.scss']
})
export class ThresholdApplicationSelectionComponent implements IWizardContentComponent, OnInit {
  @Input() step: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() subStep: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() wizardCtrl: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  @Input() componentId: string;
  @Input() stateHistory?: IComponentStateHistory;
  // eslint-disable-next-line @angular-eslint/no-output-on-prefix
  @Output() onDataValueChange = new EventEmitter<IValueChangedEvent>();
  @ViewChild('currentForm', { static: true }) form: NgForm;

  appList: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  selectedAppId: any; //eslint-disable-line @typescript-eslint/no-explicit-any
  selectedAppName: string;
  dataSource: any; //eslint-disable-line @typescript-eslint/no-explicit-any

  constructor(private readonly entityCache: EntityCacheProvider) {}

  ngOnInit() {
    this.step.form = this.form;
    this.selectedAppId = 0;
    this.selectedAppName = '';
    this.repopulateAppInfo();
    this.getAllApps();
  }

  getAllApps(): void {
    this.entityCache
      .findEntityCache('application')
      .getValuesAsync()
      .subscribe(appsList => {
        if (appsList.length > 0) {
          const apps = appsList;
          const appList = filter(apps, app => app.isUserDefined());
          this.dataSource = appList.map(a => a.applicationData);
          this.dataSource = filter(this.dataSource, app => !app.deleted);
          this.dataSource = this.filterAvailableApp(this.dataSource);
          this.appList = cloneDeep(this.dataSource);
        }
      });
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  filterDefinedApp(dataSource: any): any {
    dataSource = dataSource.content ? dataSource.content : dataSource;
    return filter(
      dataSource,
      obj => obj.applicationType === 'User-Defined' || obj.applicationType === 'User-Defined-Url'
    );
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  filterAvailableApp(applications: any): any {
    const availableIds =
      this.step.parent.defaultParamsById.dimensionValue === 'app'
        ? this.step.parent.defaultParamsById.availableIds
        : [];
    return filter(applications, app => indexOf(availableIds, app.id) === -1);
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  chooseApp(app: any): void {
    this.selectedAppId = app.id;
    this.selectedAppName = app.name;
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'appInput',
      key: 'appId',
      newValue: this.selectedAppId,
      isValid: true
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'appNameInput',
      key: 'appName',
      newValue: this.selectedAppName,
      isValid: true
    });
  }

  resetSelectedAppInformation(): void {
    this.selectedAppId = 0;
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'appInput',
      key: 'appId',
      newValue: REMOVED,
      isValid: false
    });
    this.onDataValueChange.emit({
      componentId: this.componentId,
      inputId: 'appNameInput',
      key: 'appName',
      newValue: REMOVED,
      isValid: false
    });
  }

  repopulateAppInfo(): void {
    const host = this.stateHistory(this.componentId, 'appInput');
    if (host && host.value && host.value !== REMOVED) {
      this.selectedAppId = host.value;
    }
    const appName = this.stateHistory(this.componentId, 'appNameInput');
    if (appName && appName.value && appName.value !== REMOVED) {
      this.selectedAppName = appName.value;
    }
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
  onSearchTextChange(searchText: any): any {
    searchText = searchText.toLowerCase();
    this.dataSource = filter(this.appList, (item: any) => { //eslint-disable-line @typescript-eslint/no-explicit-any
      if (item.name.toLowerCase().indexOf(searchText) >= 0) {
        return item;
      }
    });
  }
}
